import { render, staticRenderFns } from "./ClientPortalInfo.vue?vue&type=template&id=3218ab7a&"
import script from "./ClientPortalInfo.vue?vue&type=script&lang=js&"
export * from "./ClientPortalInfo.vue?vue&type=script&lang=js&"
import style0 from "./ClientPortalInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports